import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=e2e54872&scoped=true&lang=pug&"
import script from "./TicketView.vue?vue&type=script&lang=ts&"
export * from "./TicketView.vue?vue&type=script&lang=ts&"
import style0 from "./TicketView.vue?vue&type=style&index=0&id=e2e54872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e54872",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
